var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload_k"},[_c('div',{staticClass:"upload_block"},[_c('div',{attrs:{"id":"Loading"},domProps:{"innerHTML":_vm._s(_vm.videomsg)}}),_vm._v(" "),_c('input',{staticClass:"upload_input",attrs:{"id":_vm.inputname,"type":"file"},on:{"change":_vm.uploadfile}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce59ad0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadFile.vue
// module id = null
// module chunks = 